<template>

  <v-container fluid>
    <v-layout row wrap>
      <p id="mobilealert" class="title mt-4" style="width: 100%; text-align:center;">Sorry, this is not supported on mobile (or very small screens)!<br>You have to get to a computer to play.</p>
      <v-flex xs12 sm12 md12 lg8 class="webgl-content">
        <div style="margin: auto; width: 800px;">
          <div ref="gamecontainer" id="gameContainer" style="width: 800px; height: 600px; margin: auto;"></div>
        </div>
      </v-flex>
      <v-flex xs12 sm12 md12 lg4 class="pt-4 changelog">
        <p class="title">Change Log</p>
        <p class="subheading">v1.2 - Added bot strategy. Strategy is chosen randomely between the original and the new strat. (1/16)</p>
        <p class="subheading">v1.1 - Fixed bug where you could buy reserve cards you couldn't afford. (1/14)</p>
        <p class="subheading">v1.0 - Initial Release. (1/13)</p>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 sm12 md7>
        <v-card class="ma-4">
          <v-toolbar dark>
            <v-toolbar-side-icon @click="showPrevResults = !showPrevResults"></v-toolbar-side-icon>
            <v-toolbar-title style="width: 100%; display:flex; flex-direction:row; align-items:space-between; justify-content:space-between;">
              <span>All Previous Results</span>
              <span v-if="botWins && totalGames">Bot has won {{ getTotalBotWins() }}</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <!-- <p class="title">All Previous Results</p> -->
          <v-data-table v-if="showPrevResults" :headers="headers" :items="gameResults" :pagination.sync="pagination" class="elevation-1">
            <template slot="items" slot-scope="props">
              <td>{{ getWinnerString(props.item) }}</td>
              <td>{{ getPoints(props.item, true) }}</td>
              <td>{{ getPoints(props.item, false) }}</td>
              <td>{{ props.item.rounds }}</td>
              <td>{{ getBotStrat(props.item) }}</td>
              <td>{{ getDatetime(props.item.datetime) }}</td>
            </template>
          </v-data-table>
        </v-card>
        <!-- <p v-if="botWins && totalGames" class="pt-4 title">Bot has won {{ getTotalBotWins() }}</p> -->
      </v-flex>
      <v-flex xs12 sm12 md5>
        <rules-card />
      </v-flex>
    </v-layout>
  </v-container>

</template>

<script>
  import "./TemplateData/style.css";
  import Progress from "./TemplateData/MyProgress.js";
  var gameInstance = UnityLoader.instantiate("gameContainer", "Build/Builds.json", {onProgress: Progress});
  import RulesCard from "./RulesCard";
  //var gameInstance = UnityLoader.instantiate("gameContainer", "Build/Builds.json");

  import { db } from '../../firebase.js';
  import moment from 'moment';
  export default {
    data() {
      return {
        gameResults: [],
        headers: [
          { text: 'Winner', value: 'winner' },
          { text: 'Plyr Points', value: 'pPoints' },
          { text: 'Bot Points', value: 'bPoints' },
          { text: 'Rounds', value: 'rounds' },
          { text: 'Strategy', value: 'botStrat' },
          { text: 'Datetime', value: 'datetime' }
        ],
        pagination: {
          descending: true,
          sortBy: 'datetime',
          rowsPerPage: 10,
        },
        botWins: 0,
        plyrWins: 0,
        ties: 0,
        totalGames: 0,
        showPrevResults: true,
      }
    },
    methods: {
      loadResults() {
        db.collection('results').onSnapshot(snap => {
          this.gameResults = [];
          this.totalGames = 0;
          this.botWins = 0;
          this.plyrWins = 0;
          this.ties = 0;
          snap.forEach(doc => {
            //console.log("result ",doc.data());
            let data = doc.data();
            if(data.winner == 0) this.botWins++;
            else if(data.winner == 1) this.plyrWins++;
            else this.ties++;

            this.totalGames++;

            this.gameResults.push(data);
          })
          //console.log("total bot wins: "+this.botWins);
          //console.log("total games: "+this.totalGames);
          //console.log("result fetched: ",this.gameResults);
        })
      },
      getWinnerString(item) {
        if(item.winner === 0) return "Bot";
        else if(item.winner == 1) return "Plyr";
        else return "Tie";
      },
      getDatetime(datetime) {
        return moment(datetime.toDate()).format("MMM D, YYYY @ HH:mma")
      },
      getPoints(item, plyr) {
        if(plyr) {
          return item.pPoints + " (" + item.pCards + " Cards)";
        } else {
          return item.bPoints + " (" + item.bCards + " Cards)";
        }
      },
      getBotStrat(item) {
        if(item.botStrat) {
          return 1;
        }else {
          return 0;
        }
      },
      getTotalBotWins() {
        //console.log(this.botWins);
        //console.log(this.totalGames);
        let totalPerc = Number(this.botWins / this.totalGames * 100).toFixed(2);
        return this.botWins + " of "+this.totalGames + " Games ("+totalPerc+"%)";
      }
    },
    mounted() {
      this.loadResults();
      //this.$refs.gamecontainer.style = this.$refs.gamecontainer.style+"; margin: auto;";
    },
    components: {
      RulesCard,
    }
  }

</script>

<style>

/*
  @media screen and (min-width: 1400px) {
    .mainlay {
      display: flex;
      flex-direction: row;
      justify-content:center;
    }
  }
  @media screen and (max-width: 1400px) {
    .mainlay {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }
  .webgl-content {
    min-width: 800px;
    margin-right: 20px;
    margin-bottom: 25px;
    display:flex;
    flex-direction: column;
    align-items: center;
  }*/
  #gameContainer {
    //margin: auto auto;
  }
  #mobilealert {
    display:none;
  }
  .webgl-content {
  //  margin: auto;
  }

  @media only screen and (max-width: 800px) {

  }

  @media only screen and (max-width: 799px) {
    #gameContainer {
      display:none;
    }
    #mobilealert {
      display:block;
    }
    .changelog {
      display:none;
    }
  }

</style>
